const {
  CHAIN_ID,
  TOKEN,
  TOKEN_IMAGE,
  PROVIDER_URL,
  ROUTER_ADDRESS,
  FACTORY_ADDRESS,
  SERVER
} = require('./config');

const ethers = require("ethers").ethers;
const axios = require('axios');

const PROVIDER = new ethers.providers.JsonRpcProvider(PROVIDER_URL);
const PK = (ethers.Wallet.createRandom()).privateKey;
const WALLET = new ethers.Wallet(PK, PROVIDER);

const TOKEN_JSON = require('./json/TraderbotXToken.json');
const TOKEN_ABI = TOKEN_JSON.abi;
const TOKEN_ADDRESS = TOKEN_JSON.networks[CHAIN_ID].address;

const VAULT_JSON = require('./json/Vaultv4.json');
const VAULT_ABI = VAULT_JSON.abi;
const VAULT_ADDRESS = VAULT_JSON.networks[CHAIN_ID].address;

const NFT_JSON = require('./json/TraderbotXNFT.json');
const NFT_ABI = NFT_JSON.abi;
const NFT_ADDRESS = NFT_JSON.networks[CHAIN_ID].address;

const SESSION_JSON = require('./json/Session.json');
const SESSION_ABI = SESSION_JSON.abi;
const SESSION_ADDRESS = SESSION_JSON.networks[CHAIN_ID].address;

const ROUTER_ABI = require('./json/IROUTER.json').abi;
const FACTORY_ABI = require('./json/IFACTORY.json').abi;

const PVR_JSON = require('./json/PosVaultRewardV2.json');
const PVR_ABI = PVR_JSON.abi;
const PVR_ADDRESS = PVR_JSON.networks[CHAIN_ID].address;

const POSVAULT_JSON = require('./json/PosVaultV2.json');
const POSVAULT_ABI = POSVAULT_JSON.abi;
const POSVAULT_ADDRESS = POSVAULT_JSON.networks[CHAIN_ID].address;

const POSPOOL_JSON = require('./json/IPOSPOOL.json');
const POSPOOL_ABI = POSPOOL_JSON.abi;
const POSPOOL_ADDRESS = '0x3cbc6f7d406fe9701573fe6ddf28f4f17b5d46a3';
const posPool = new ethers.Contract(POSPOOL_ADDRESS, POSPOOL_ABI, WALLET);

const LPVAULT_JSON = require('./json/LPVault.json');
const LPVAULT_ABI = LPVAULT_JSON.abi;
const LPVAULT_ADDRESS = LPVAULT_JSON.networks[CHAIN_ID].address;

const PAIR_JSON = require('./json/IPAIR.json');
const PAIR_ABI = PAIR_JSON.abi;
const PAIR_ADDRESS = '0x2c5224B24277134cb5CeC82541D23c2f769205de';
const pairLP = new ethers.Contract(PAIR_ADDRESS, PAIR_ABI, WALLET);

const ZV_JSON = require('./json/ZOVault.json');
const ZV_ABI = ZV_JSON.abi;
const ZV_ADDRESS = ZV_JSON.networks[CHAIN_ID].address;

const ZVR_JSON = require('./json/ZOVaultReward.json');
const ZVR_ABI = ZVR_JSON.abi;
const ZVR_ADDRESS = ZVR_JSON.networks[CHAIN_ID].address;

console.log({ ZV_ADDRESS, ZVR_ADDRESS });

async function detectMetamask() {
  if (!window.ethereum) throw new Error('Please install Metamask and reload!');

  window.ethereum.on('chainChanged', (_chainId) => window.location.reload());

  let chainId = await window.ethereum.request({ method: 'eth_chainId' });
  chainId = Number(chainId);
  if (chainId !== CHAIN_ID) throw new Error('Please connect Metamask to Conflux eSpace!');

  return window.ethereum.isConnected();
}

async function loadMetamask() {
  window.ethereum.enable();
  let provider = new ethers.providers.Web3Provider(window.ethereum);
  return provider;
}

async function loadWalletRandom() {
  const tmp = ethers.Wallet.createRandom();
  return await loadWallet(tmp.privateKey);
}

async function loadWallet(pk) {
  let provider = new ethers.providers.JsonRpcProvider(PROVIDER_URL);
  const wallet = new ethers.Wallet(pk, provider);
  return wallet;
}

async function getBlockchainTime() {
  let provider = PROVIDER;
  const blockNum = await provider.getBlockNumber();
  const block = await provider.getBlock(blockNum);
  return block.timestamp;
}

async function getWalletBalance(address) {
  let provider = PROVIDER;
  const balance = await provider.getBalance(address);
  return balance;
}

function wei2eth(wei) {
  return ethers.utils.formatUnits(wei, "ether");
}

function eth2wei(eth) {
  return ethers.utils.parseEther(eth);
}

function toBN(val) {
  return ethers.BigNumber.from(val);
}

async function getSwapData(wallet) {
  const router = new ethers.Contract(ROUTER_ADDRESS, ROUTER_ABI, wallet);
  const WETH_ADDRESS = await router.WETH();
  async function getPrice(eth) {
    let amountIn = ethers.utils.parseEther(eth); // 1E18 TOKEN = ? COIN
    let path = [
      TOKEN_ADDRESS,
      WETH_ADDRESS
    ];
    console.log(amountIn.toString());
    let result = await router.getAmountsOut(amountIn, path);

    const price = result[1];
    return price;
  }

  const price = await getPrice('1');

  const factory = new ethers.Contract(FACTORY_ADDRESS, FACTORY_ABI, wallet);
  const pairAddress = await factory.getPair(
    TOKEN_ADDRESS,
    WETH_ADDRESS
  );

  const pair = new ethers.Contract(pairAddress, PAIR_ABI, wallet);
  const reserves = await pair.getReserves();
  const token0 = await pair.token0();

  let reserveToken;
  let reserveCoin;

  if (token0 === TOKEN_ADDRESS) {
    reserveToken = reserves[0];
    reserveCoin = reserves[1];
  } else if (token0 === WETH_ADDRESS) {
    reserveCoin = reserves[0];
    reserveToken = reserves[1];
  }

  return {
    pairAddress,
    price,
    reserveCoin,
    reserveToken
  }
}

async function getNFTData(wallet) {
  const nft = new ethers.Contract(NFT_ADDRESS, NFT_ABI, wallet);
  const data = await nft.getStat();
  const totalPayment = data[0];
  const numNFT = data[1];

  return {
    totalPayment,
    numNFT
  }
}

async function getNFTDataAtIndex(wallet, index) {
  const nft = new ethers.Contract(NFT_ADDRESS, NFT_ABI, wallet);
  const data = await nft.getNFTData(index);

  return {
    id: data[0],
    createdTime: data[1],
    refId: data[2],
    share: data[3]
  }
}

async function mintNFT(signer, amountCoin, refId) {
  console.log('mintNFT');
  const nft = new ethers.Contract(NFT_ADDRESS, NFT_ABI, signer);
  const address = await signer.getAddress();
  const tx = await nft.mint(address, refId, { value: amountCoin });
  console.log('nft.mint tx: ' + tx.hash);
  return tx;
}

async function getVaultData(wallet, address) {
  const balance = await wallet.provider.getBalance(VAULT_ADDRESS);

  const vault = new ethers.Contract(VAULT_ADDRESS, VAULT_ABI, wallet);

  const amountInToken = ethers.utils.parseEther('1'); // 1 TOKEN = ? COIN
  const amountOutCoin = await vault.tokenToCoin(amountInToken, address);
  const amountInCoin = ethers.utils.parseEther('1');
  const amountOutToken = await vault.coinToToken(amountInCoin, address);

  const basePrice = await vault.getBasePrice();

  return {
    balance,
    price: amountOutCoin,
    priceReverse: amountOutToken,
    basePrice: basePrice.toString()
  }
}

async function getSessionData(wallet) {
  const token = new ethers.Contract(TOKEN_ADDRESS, TOKEN_ABI, wallet);
  const balanceToken = await token.balanceOf(SESSION_ADDRESS);
  const session = new ethers.Contract(SESSION_ADDRESS, SESSION_ABI, wallet);
  const sss = await session.getStat();

  const history = [];
  const ns = sss[2].toNumber();
  if (ns > 1) {
    for (let i = 1; i < ns; i++) {
      const s = await session.getDataAtIndex(i);
      history.unshift({
        turn: s[0],
        totalShare: s[1],
        totalGenerated: s[2],
        profitPerShare: s[3],
        createdAt: s[4],
        snapshotPrice: s[5]
      });
    }
  }

  return {
    balanceToken,
    currentTurn: sss[0],
    currentTotalShare: sss[1],
    numSession: sss[2],
    history
  }
}

async function getOwnedNFTData(wallet, address) {
  const session = new ethers.Contract(SESSION_ADDRESS, SESSION_ABI, wallet);
  const nft = new ethers.Contract(NFT_ADDRESS, NFT_ABI, wallet);

  const sss = await session.getStat();
  const currentTurn = sss[0].toNumber();

  const numOwned = await nft.balanceOf(address);
  const nfts = [];
  for (let i = 0; i < numOwned; i++) {
    const id = await nft.tokenOfOwnerByIndex(address, i);
    const data = await session.getNFTData(id);

    const nftData1 = {
      id,
      startTurn: data[0],
      refId: data[1],
      share: data[2],
      uri: SERVER + '/nft?nftId=' + id
    }

    let metadata = {};

    try {
      const result = await axios.get(nftData1.uri);
      metadata = result.data;
    } catch (err) {
      console.error(err);
    }

    nftData1.metadata = metadata;

    const nftData2 = await getNFTHistory(wallet, id, currentTurn, nftData1.startTurn, nftData1.share);
    const nftData = Object.assign({}, nftData1, nftData2);
    nfts.push(nftData);
  }

  return nfts;
}

async function getOwnedNFTDataUri(wallet, address) {
  const nft = new ethers.Contract(NFT_ADDRESS, NFT_ABI, wallet);

  const numOwned = await nft.balanceOf(address);
  const nfts = [];
  for (let i = 0; i < numOwned; i++) {
    const id = await nft.tokenOfOwnerByIndex(address, i);

    const nftData1 = {
      id,
      uri: SERVER + '/nft?nftId=' + id
    }

    let metadata = {};

    try {
      const result = await axios.get(nftData1.uri);
      metadata = result.data;
    } catch (err) {
      console.error(err);
    }

    nftData1.metadata = metadata;
    nfts.push(nftData1);
  }

  return nfts;
}

async function getOwnedNFTDetail(nftId, wallet) {
  console.log('getOwnedNFTDetail: ', nftId);
  const session = new ethers.Contract(SESSION_ADDRESS, SESSION_ABI, wallet);
  const sss = await session.getStat();
  const currentTurn = sss[0].toNumber();
  const data = await session.getNFTData(nftId);

  const nftData1 = {
    startTurn: data[0],
    refId: data[1],
    share: data[2]
  }

  const nftData2 = await getNFTHistory(wallet, nftId, currentTurn, nftData1.startTurn, nftData1.share);
  const nftData = Object.assign({}, nftData1, nftData2);
  console.log('getOwnedNFTDetail: done');
  return nftData;
}

async function getNFTHistory(wallet, nftId, currentTurn, startTurn, share) {
  const session = new ethers.Contract(SESSION_ADDRESS, SESSION_ABI, wallet);

  let totalUnclaimed = ethers.BigNumber.from(0);
  const unclaimedTurns = [];

  for (let turn = startTurn; turn < currentTurn; turn++) {
    const claimed = await session.getNFTClaimed(nftId, turn);
    if (claimed.gt(0)) continue;

    const data = await session.getDataAtIndex(turn);
    const profitPerShare = data[3];
    const profit = profitPerShare.mul(share);
    const unclaimed = profit.sub(claimed);
    totalUnclaimed = totalUnclaimed.add(unclaimed);

    if (claimed.toString() !== profit.toString()) {
      unclaimedTurns.push(turn);
    }
  }

  const ret = {
    totalUnclaimed,
    unclaimedTurns
  }
  return ret;
}

// async function getNFTHistory(wallet, nftId, currentTurn, startTurn, share) {
//   const session = new ethers.Contract(SESSION_ADDRESS, SESSION_ABI, wallet);

//   let totalProfit = ethers.BigNumber.from(0);
//   let totalClaimed = ethers.BigNumber.from(0);
//   let totalUnclaimed = ethers.BigNumber.from(0);
//   const history = [];
//   const unclaimedTurns = [];

//   // for (let turn = (currentTurn - 1); turn >= startTurn.toNumber(); turn--) {
//   for (let turn = startTurn; turn < currentTurn.toNumber(); turn++) {

//     const data = await session.getDataAtIndex(turn);
//     const profitPerShare = data[3];
//     const profit = profitPerShare.mul(share);
//     totalProfit = totalProfit.add(profit);

//     const claimed = await session.getNFTClaimed(nftId, turn);
//     totalClaimed = totalClaimed.add(claimed);

//     const unclaimed = profit.sub(claimed);
//     totalUnclaimed = totalUnclaimed.add(unclaimed);

//     if (claimed.toString() !== profit.toString()) {
//       unclaimedTurns.push(turn);
//     }

//     history.push({ turn, profit, claimed, unclaimed });

//     if (unclaimed.eq('0')) break;
//   }

//   const ret = {
//     // totalProfit,
//     // totalClaimed,
//     // history,
//     totalUnclaimed,
//     unclaimedTurns
//   }
//   return ret;
// }

async function claimNFTProfit(signer, nftId, turns) {
  console.log('claimNFTProfit');
  const session = new ethers.Contract(SESSION_ADDRESS, SESSION_ABI, signer);
  const tx = await session.claimReward(nftId, turns);
  console.log('session.claimReward tx: ' + tx.hash);
  return tx;
}

async function addTokenToMetamask() {
  const tokenAddress = TOKEN_ADDRESS;
  const tokenSymbol = TOKEN;
  const tokenDecimals = 18;
  const tokenImage = TOKEN_IMAGE;

  try {
    // wasAdded is a boolean. Like any RPC method, an error may be thrown.
    const wasAdded = await window.ethereum.request({
      method: 'wallet_watchAsset',
      params: {
        type: 'ERC20', // Initially only supports ERC20, but eventually more!
        options: {
          address: tokenAddress, // The address that the token is at.
          symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
          decimals: tokenDecimals, // The number of decimals in the token
          image: tokenImage, // A string url of the token logo
        },
      },
    });

    if (wasAdded) {
      console.log('token added!');
    } else {
      console.log('token not added!');
    }
  } catch (error) {
    console.error(error);
  }
}

async function getCfxPrice(wallet, amountIn) {
  const router = new ethers.Contract(ROUTER_ADDRESS, ROUTER_ABI, wallet);
  const WETH_ADDRESS = await router.WETH();

  let path = [
    TOKEN_ADDRESS,
    WETH_ADDRESS
  ];

  if (amountIn.eq(0)) return ethers.BigNumber.from(0);
  let result = await router.getAmountsOut(amountIn, path);

  const price = result[1];
  return price;
}

async function getPosVaultData() {
  const wallet = WALLET;
  const pvr = new ethers.Contract(PVR_ADDRESS, PVR_ABI, wallet);

  const posPoolData = await posPool.userSummary(POSVAULT_ADDRESS);
  const stakeOnPVR = (await pvr.currentTotalStake()).toNumber();
  const stakeOnPP = posPoolData.available.toNumber();
  const retiredMode = (stakeOnPVR !== stakeOnPP);
  console.log({ stakeOnPVR, stakeOnPP, retiredMode });

  const dailyInterest = await pvr.getAverageDailyInterest();
  const dailyInterestCfx = await getCfxPrice(wallet, dailyInterest);
  const priceToken = await getCfxPrice(wallet, ethers.utils.parseEther('1'));

  const ret = {
    retiredMode,
    priceToken: ethers.utils.formatEther(priceToken.toString()),
    dailyInterest: ethers.utils.formatEther(dailyInterest.toString()),
    dailyInterest1000Cfx: ethers.utils.formatEther(dailyInterestCfx.toString()),
    dailyInterest1Cfx: ethers.utils.formatEther(dailyInterestCfx.div(1000).toString())
  };

  ret.apyCalc1 = Math.pow((1 + Number(ret.dailyInterest1Cfx)), 365);
  ret.apyCalc2 = ret.apyCalc1 - 1;
  ret.apy = ret.apyCalc2 * 100;

  const rhLength = await pvr.numRewardHistory();
  const rhIndex = rhLength.toNumber() - 1;
  const rh = await pvr.getRewardHistory(rhIndex);
  const lastRewardTime = rh[3].toNumber();
  ret.nextRewardAvailable = lastRewardTime + (24 * 3600);

  console.log(ret);

  return ret;
}

async function getPosVaultDataUser(wallet) {
  const pvr = new ethers.Contract(PVR_ADDRESS, PVR_ABI, wallet);

  const ret = {
  };

  const ownedCFX = await getWalletBalance(wallet.address);
  ret.ownedCFX = ethers.utils.formatEther(ownedCFX.toString());

  const pv = new ethers.Contract(POSVAULT_ADDRESS, POSVAULT_ABI, wallet);
  const ud = await pv.userData(wallet.address);

  const numStake = ud[0];
  let unstakeTime = ud[1].toNumber();
  // hardcode hack
  // phx pool lock period still 7 days, so it must be added 6 days to be 13 days
  unstakeTime += (3600 * 24 * 6);
  const wrLength = ud[2].toNumber();

  ret.numStake = ethers.utils.formatEther(numStake.toString());
  ret.unstakeTime = unstakeTime;
  ret.wrLength = wrLength;

  const pendingWithdraw = [];
  for (let i = 0; i < wrLength; i++) {
    const data = await pv.userWithdrawRequestData(wallet.address, i);
    const wrIndex = data[0].toNumber();
    const claimer = data[1];
    const withdrawAmount = data[2];
    const deadline = data[3].toNumber();
    const done = data[4];

    if (!done && claimer.toLowerCase() === wallet.address.toLowerCase()) {
      pendingWithdraw.push({
        wrIndex,
        withdrawAmount: ethers.utils.formatEther(withdrawAmount.toString()),
        deadline
      });
    }
  }
  ret.pendingWithdraw = pendingWithdraw;

  const ur = await pvr.getUnclaimedReward(wallet.address);
  ret.unclaimedReward = ethers.utils.formatEther(ur.toString());
  console.log('** getPosVaultDataUser **');
  console.log(ret);
  return ret;
}

async function claimPosVaultYield(signer) {
  console.log('claimPosVaultYield');
  const posVaultReward = new ethers.Contract(PVR_ADDRESS, PVR_ABI, signer);
  const tx = await posVaultReward.claimReward();
  console.log('posVaultReward.claimReward tx: ' + tx.hash);
  return tx;
}

async function stakePosVault(signer, amount) {
  console.log('stakePosVault');
  const posVault = new ethers.Contract(POSVAULT_ADDRESS, POSVAULT_ABI, signer);
  let opt = {
    value: ethers.utils.parseEther(amount)
  }
  const tx = await posVault.stake(opt);
  console.log('posVault.stake tx: ' + tx.hash);
  return tx;
}

async function unstakePosVault(signer, amount) {
  console.log('unstakePosVault');
  const posVault = new ethers.Contract(POSVAULT_ADDRESS, POSVAULT_ABI, signer);
  const amountWei = ethers.utils.parseEther(amount);
  const tx = await posVault.unstake(amountWei);
  console.log('posVault.unstake tx: ' + tx.hash);
  return tx;
}

async function claimPosVaultWithdraw(signer, index) {
  console.log('claimPosVaultWithdraw');
  const posVault = new ethers.Contract(POSVAULT_ADDRESS, POSVAULT_ABI, signer);
  const tx = await posVault.claimWithdraw(index);
  console.log('posVault.unstake tx: ' + tx.hash);
  await tx.wait();
  return tx;
}

async function getLPVaultData() {
  const wallet = WALLET;
  const lpVault = new ethers.Contract(LPVAULT_ADDRESS, LPVAULT_ABI, wallet);

  // const staked = (await lpVault.currentTotalStake()).toString();
  const avgDailyInterest = await lpVault.getAverageDailyInterest();

  let dailyInterest = avgDailyInterest;
  const numHistory = (await lpVault.numRewardHistory()).toNumber();
  if (numHistory >= 3) {
    const N = numHistory - 1;
    const rowN = await lpVault.getRewardHistory(N);
    const rowNM1 = await lpVault.getRewardHistory(N - 1);
    const lastDeltaTime = rowN[3].sub(rowNM1[3]);
    const lastReward = rowN[2];
    const oneDay = 3600 * 24;
    const lastDailyInterest = lastReward.mul(oneDay).div(lastDeltaTime);
    dailyInterest = lastDailyInterest;
  }

  // const currentTotalStake = await lpVault.currentTotalStake();
  // const currentTurn = await lpVault.currentTurn();
  // const startRewardTime = await lpVault.startRewardTime();
  const lastRewardTime = await lpVault.lastRewardTime();
  const nextRewardAvailable = lastRewardTime.toNumber() + (3600 * 24);
  // const totalRewardPerStake = await lpVault.totalRewardPerStake();

  const dailyInterestCfx = await getCfxPrice(wallet, dailyInterest);
  const priceToken = await getCfxPrice(wallet, ethers.utils.parseEther('1'));

  // calc 1LP = ? CFX

  const totalSupplyLP = await pairLP.totalSupply();
  const reserves = await pairLP.getReserves();
  const reserve0 = reserves[0];
  // const reserve1 = reserves[1];

  console.log('** calc LP APY **');
  const singleLP = ethers.utils.parseEther('1');

  const oneLP2CFX = singleLP.mul(reserve0).div(totalSupplyLP); // price of 1 LP in CFX
  // const oneLP2TXT = singleLP.mul(reserve1).div(totalSupplyLP); // price of 1 LP in TXT

  const ret = {
    priceToken: ethers.utils.formatEther(priceToken.toString()),
    priceLP: ethers.utils.formatEther(oneLP2CFX.toString()),
    dailyInterest: ethers.utils.formatEther(dailyInterest.toString()),
    dailyInterestCFX: ethers.utils.formatEther(dailyInterestCfx.toString()),
    lastRewardTime: lastRewardTime.toNumber(),
    apy: 0,
    nextRewardAvailable
  };

  const interest = Number(ret.dailyInterestCFX) / Number(ret.priceLP);
  const apyCalc1 = Math.pow((1 + Number(interest)), 365);
  const apyCalc2 = apyCalc1 - 1;
  const apy = apyCalc2 * 100;
  // const apy = Math.pow((1 + Number(interest)), 365) * 100;

  ret.apyCalc1 = apyCalc1;
  ret.apyCalc2 = apyCalc2;
  ret.apy = apy;
  ret.interest = interest;

  console.log('LP Vault Data:');
  console.log(ret);

  return ret;
}

async function getLPVaultDataUser(wallet) {
  const lpVault = new ethers.Contract(LPVAULT_ADDRESS, LPVAULT_ABI, wallet);

  const userData = await lpVault.getUserData(wallet.address);
  const numStake = userData[1];
  const unstakeTime = await userData[2];
  const unclaimedReward = await lpVault.getUnclaimedReward(wallet.address);
  const ownedLP = await pairLP.balanceOf(wallet.address);
  const approved = await pairLP.allowance(wallet.address, LPVAULT_ADDRESS);

  const ret = {
    numStake: ethers.utils.formatEther(numStake.toString()),
    unstakeTime: unstakeTime.toNumber(),
    unclaimedReward: ethers.utils.formatEther(unclaimedReward.toString()),
    ownedLP: ethers.utils.formatEther(ownedLP.toString()),
    approved: approved.gt(0)
  };

  console.log('LP Vault Data User:');
  console.log(ret);
  return ret;
}

async function approveLPVault(signer) {
  console.log('approveLPVault');
  const pairLP = new ethers.Contract(PAIR_ADDRESS, PAIR_ABI, signer);
  const tx = await pairLP.approve(LPVAULT_ADDRESS, ethers.constants.MaxUint256);
  console.log('pairLP.approve tx:', tx.hash);
  return tx;
}

async function stakeLPVault(signer, amount) {
  console.log('stakeLPVault');
  const stakeAmount = ethers.utils.parseEther(amount);
  const lpVault = new ethers.Contract(LPVAULT_ADDRESS, LPVAULT_ABI, signer);
  const tx = await lpVault.stakeLPToken(stakeAmount);
  console.log('lpVault.stakeLPToken tx:', tx.hash);
  return tx;
}

async function unstakeLPVault(signer, amount) {
  console.log('unstakeLPVault');
  const stakeAmount = ethers.utils.parseEther(amount);
  const lpVault = new ethers.Contract(LPVAULT_ADDRESS, LPVAULT_ABI, signer);
  const tx = await lpVault.unstakeLPToken(stakeAmount);
  console.log('lpVault.unstakeLPToken tx:', tx.hash);
  return tx;
}

async function claimLPVaultYield(signer) {
  console.log('claimLPVaultYield');
  const lpVault = new ethers.Contract(LPVAULT_ADDRESS, LPVAULT_ABI, signer);
  const tx = await lpVault.claimReward();
  console.log('lpVault.claimReward tx: ' + tx.hash);
  return tx;
}

async function getZoVaultData() {
  const wallet = WALLET;
  const zv = new ethers.Contract(ZV_ADDRESS, ZV_ABI, wallet);
  const zvr = new ethers.Contract(ZVR_ADDRESS, ZVR_ABI, wallet);

  const stakeOnZV = await zv.totalStake();

  console.log('** zo vault data **');
  console.log('stakeOnZV: ', stakeOnZV.toString());

  const totalRewardPerStake = await zvr.totalRewardPerStake();
  console.log('totalRewardPerStake: ', totalRewardPerStake.toString());

  const dailyInterest = await zvr.getAverageDailyInterest();
  console.log('avgDailyInterest: ', dailyInterest.toString());

  const dailyInterestCfx = await getCfxPrice(wallet, dailyInterest);
  console.log('avgDailyInterestCFX: ', dailyInterestCfx.toString());

  const priceToken = await getCfxPrice(wallet, ethers.utils.parseEther('1'));

  const ret = {
    staked: ethers.utils.formatEther(stakeOnZV.toString()),
    priceToken: ethers.utils.formatEther(priceToken.toString()),
    dailyInterest: ethers.utils.formatEther(dailyInterest.toString()),
    dailyInterestCfx: ethers.utils.formatEther(dailyInterestCfx.toString())
  };

  ret.apyCalc1 = Math.pow((1 + Number(ret.dailyInterestCfx)), 365);
  ret.apyCalc2 = ret.apyCalc1 - 1;
  ret.apy = ret.apyCalc2 * 100;

  const rhLength = await zvr.numRewardHistory();
  const rhIndex = rhLength.toNumber() - 1;
  const rh = await zvr.getRewardHistory(rhIndex);
  const lastRewardTime = rh[3].toNumber();
  ret.nextRewardAvailable = lastRewardTime + (24 * 3600);

  console.log(ret);

  return ret;
}

async function getZoVaultDataUser(wallet) {
  const zv = new ethers.Contract(ZV_ADDRESS, ZV_ABI, wallet);
  const zvr = new ethers.Contract(ZVR_ADDRESS, ZVR_ABI, wallet);

  const ret = {
  };

  const ownedCFX = await getWalletBalance(wallet.address);
  ret.ownedCFX = ethers.utils.formatEther(ownedCFX.toString());

  const ud = await zv.userData(wallet.address);

  const numStake = ud[0];
  const unstakeTime = ud[1].toNumber();

  ret.numStake = ethers.utils.formatEther(numStake.toString());
  ret.unstakeTime = unstakeTime;

  const ur = await zvr.getUnclaimedReward(wallet.address);
  ret.unclaimedReward = ethers.utils.formatEther(ur.toString());

  console.log('** ZOVaultDataUser **');
  console.log(ret);
  return ret;
}

async function claimZoVaultYield(signer) {
  console.log('claimZoVaultYield');
  const zvr = new ethers.Contract(ZVR_ADDRESS, ZVR_ABI, signer);
  const tx = await zvr.claimReward();
  console.log('zvr.claimReward tx: ' + tx.hash);
  return tx;
}

async function stakeZoVault(signer, amount) {
  console.log('stakePosVault');
  const zv = new ethers.Contract(ZV_ADDRESS, ZV_ABI, signer);
  let opt = {
    value: ethers.utils.parseEther(amount)
  }
  const tx = await zv.stake(opt);
  console.log('zv.stake tx: ' + tx.hash);
  return tx;
}

async function unstakeZoVault(signer, amount) {
  console.log('unstakeZoVault');
  const zv = new ethers.Contract(ZV_ADDRESS, ZV_ABI, signer);
  const amountWei = ethers.utils.parseEther(amount);
  const tx = await zv.unstake(amountWei);
  console.log('zv.unstake tx: ' + tx.hash);
  return tx;
}

export default {
  // module.exports = {
  CHAIN_ID,
  TOKEN_ADDRESS,
  detectMetamask,
  loadMetamask,
  loadWalletRandom,
  loadWallet,
  getBlockchainTime,
  getWalletBalance,
  wei2eth,
  eth2wei,
  toBN,
  getSwapData,
  getVaultData,
  getNFTData,
  getNFTDataAtIndex,
  mintNFT,
  getSessionData,
  getOwnedNFTData,
  getOwnedNFTDataUri,
  getOwnedNFTDetail,
  claimNFTProfit,
  addTokenToMetamask,
  getPosVaultData,
  getPosVaultDataUser,
  claimPosVaultYield,
  stakePosVault,
  unstakePosVault,
  claimPosVaultWithdraw,
  getLPVaultData,
  getLPVaultDataUser,
  approveLPVault,
  stakeLPVault,
  unstakeLPVault,
  claimLPVaultYield,
  getZoVaultData,
  getZoVaultDataUser,
  claimZoVaultYield,
  stakeZoVault,
  unstakeZoVault
};

